'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardHeader = require('../ContentCardHeader');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

var _ContentCardImage = require('../ContentCardImage');

var _ContentCardImage2 = _interopRequireDefault(_ContentCardImage);

var _ContentCardText = require('../ContentCardText/ContentCardText');

var _ContentCardText2 = _interopRequireDefault(_ContentCardText);

var _withContentCardFooter = require('../../hocs/withContentCardFooter');

var _withContentCardFooter2 = _interopRequireDefault(_withContentCardFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TheScoreArticleContentCardItem = function TheScoreArticleContentCardItem(props) {
  return _react2.default.createElement(
    'div',
    null,
    props.imageURL && _react2.default.createElement(_ContentCardImage2.default, {
      alt: props.imageAltText,
      src: props.imageURL
    }),
    _react2.default.createElement(_ContentCardHeader2.default, {
      iconType: 'read'
    }),
    _react2.default.createElement(_ContentCardText2.default, { isLarge: props.isLarge, text: props.title }),
    props.messengerShareButton
  );
};

TheScoreArticleContentCardItem.propTypes = {
  imageAltText: _propTypes2.default.string,
  imageURL: _propTypes2.default.string,
  messengerShareButton: _propTypes2.default.node,
  title: _propTypes2.default.string.isRequired,
  isLarge: _propTypes2.default.bool
};

TheScoreArticleContentCardItem.defaultProps = {
  imageAltText: '',
  imageURL: null,
  messengerShareButton: null,
  isLarge: false
};

TheScoreArticleContentCardItem.displayName = 'TheScoreArticleContentCardItem';

exports.default = (0, _withContentCardFooter2.default)(TheScoreArticleContentCardItem);